<template>
  <div style="margin:20px 0;height:100%" ref="analyseBox">
    <a-table 
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :row-key="record => record.id"
      bordered
      :scroll="{ x:400, y }"
    >
      <span slot="customTitle"><a-icon @click="fixedCol"  type="pushpin" :theme="filled ? 'filled' : 'outlined'" /> 名称</span>
      <a-tooltip slot="name" slot-scope="text,record">
        <template slot="title">
          {{overseasFlag == '1' ? (record.aliasName || text) : text}}
        </template>
        <span class="nameStyle">{{overseasFlag == '1' ? (record.aliasName || text) : text}}</span>
      </a-tooltip>
    </a-table>
  </div>
</template>

<script>
import { formulaMixins } from '../unitls'
import { exportExcel } from "@/Utils/excel/Export2Excel";
export default {
  props:['result','filterVal'],
  mixins:[formulaMixins],
  data(){
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      y: 500,
      columns:[
        {
          dataIndex:'name',
          width: 160,
          fixed: 'left',
          // title:"名称",
          ellipsis: true,
          scopedSlots: {customRender: 'name'},
          slots: { title: 'customTitle' },
        },
        {
          dataIndex:'code',
          width: 150,
          title:"代码",
        },
      ],
      dataSource:[],
      filled: true
    }
  },
  mounted(){
    this.initTableData()
    this.y = this.$refs.analyseBox.offsetHeight - 200
  },
  watch:{
    filterVal(){
      this.initTableData(true)
    }
  },
  methods:{
    changeColumns2(){
      // let rawColumnsValue = [...this.rawColumnsValue]
      if(this.filled){
        this.columns[0].fixed = 'left'
      }else{
        delete this.columns[0].fixed
      }
      // this.setState({rawColumnsValue})
    },
    fixedCol(e){
      this.filled = !this.filled
      this.changeColumns2()
      e = e || window.event;  
      if(e.stopPropagation) { //W3C阻止冒泡方法  
          e.stopPropagation();  
      } else {  
          e.cancelBubble = true; //IE阻止冒泡方法  
      }
    },
    initTableData(addFlag){
      const {ladderList,rawResList} = this.result
      if(rawResList && ladderList){
        if(!addFlag){
          let columns= JSON.parse(JSON.stringify( this.columns))
          ladderList.forEach(item => {
            columns.push( {
              dataIndex:item,
              title:item,
              width:100,
              align:'center',
            })
          })
          this.columns = columns
        }
        
        const dataSource = []
        rawResList.forEach((i,id) => {
          i.forEach((item,index) => {
              const val = {[ladderList[id]]:item.uasge}
              const condition = i=>i.code === item.code
              if(dataSource.some(condition)){
                const idx = dataSource.findIndex(condition)
                dataSource.splice(idx,1,{...dataSource.filter(condition)[0],...val})
              } else {
                dataSource.push({
                  ...item,
                  id:`${id}${index}`,
                  ...val
                })
              }
          })
        })
        let arr = rawResList[0]
        dataSource.forEach( item =>{
          arr.forEach((i,id) =>{
            if(item.code === i.code) {
              arr[id] = {...item, ...i}
            }
          })
        }, [])
        let list = []
        let first = {}
        arr.forEach(el => {
          let flag = false
          let numArr = []
          if(this.filterVal === '所有原料'){
            flag = false
          }else if(this.filterVal === '组分有差异'){
            ladderList.forEach(feild => {
              if(!numArr.includes(el[feild])) numArr.push(el[feild])
            })
            if(numArr.length > 1){
              flag = false
            }else{
              flag = true
            }
          }else if(this.filterVal === '组分无差异'){
            ladderList.forEach(feild => {
              if(!numArr.includes(el[feild]) && el[feild] != 0) numArr.push(el[feild])
            })
            if(numArr.length === 1){
              flag = false
            }else{
              flag = true
            }
          }else if(this.filterVal === '拒绝原料'){
            ladderList.forEach(feild => {
              if(el[feild] > 0){
                flag = true
              }
            })
          }
          if(el.code === this.rawSelect.rawCode) {
            flag = true
            first = el
          }
          !flag && list.push(el)
        })
        list.unshift(first)
        this.dataSource = list
      }
    },

    downloadExcel() {
      let tHeader = this.columns.map((item) => {
        if(item.dataIndex != 'x') return item.title || '名称'
      });
      let filterVal = this.columns.map((item) => item.dataIndex);
      let tTitle = `${this.detail.taskName}-${new Date().getTime()}`;
      const list = this.dataSource;
      const data = this.formatJson(filterVal, list);
      exportExcel(tHeader, data, tTitle);
    },
    formatJson(filterVal, jsonData) {
      // let arr = ['code','name']
      return jsonData.map((v) => filterVal.map((j) => {
        return v[j]
        // if(!arr.includes(j)){
        //   return v[j] || v[j] === 0 ? Number(v[j]).toFixed(2) : ''
        // }else{
        //   return v[j]
        // }
      }));
    },
  }
}
</script>

<style>

</style>